import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import { justForSideEffectWithPayload, justForSideEffect } from 'src/infrastructure/saga.helpers'
import {
  GetReceivementOverviewListSagaPayload, GetReceivementStatusListPayload, ReceivementOverviewListState, SetDateIntervalPayload, SetReceivementOverviewListPayload, UpdateOverviewFilterFieldPayload,
} from './ReceivementOverviewListTypes'

const initialState: ReceivementOverviewListState = {
  page: 1,
  pageSize: 10,
  receivements: [],
  startDate: dayjs().subtract(2, 'day').startOf('day'),
  endDate: dayjs().endOf('day'),
  fcActive: true,
  receivementStatusList: [],
  totalPages: 0,
}

const getReceivementOverviewList = justForSideEffectWithPayload<GetReceivementOverviewListSagaPayload>()
const getReceivementStatusList = justForSideEffectWithPayload<GetReceivementStatusListPayload>()
const getFilterSuppliers = justForSideEffect()

const setReceivementOverviewList = (state: ReceivementOverviewListState, {
  payload: {
    page, pageSize, totalPages, receivements, totalItems,
  },
}: PayloadAction<SetReceivementOverviewListPayload>) => ({
  ...state,
  receivements: page === 1 ? receivements : [...state.receivements, ...receivements],
  totalPages,
  pageSize,
  page,
  totalItems,
})

const setDateInterval = (
  state: ReceivementOverviewListState,
  { payload }: PayloadAction<SetDateIntervalPayload>,
): ReceivementOverviewListState => ({
  ...state,
  startDate: payload.startDate,
  endDate: payload.endDate,
})

const updateOverviewFilterField = (state, action: PayloadAction<UpdateOverviewFilterFieldPayload>) => {
  const { key, value } = action.payload
  return { ...state, [key]: value }
}

const clearFilters = (
  state: ReceivementOverviewListState,
): ReceivementOverviewListState => ({
  ...state,
  startDate: dayjs().subtract(2, 'day').startOf('day'),
  endDate: dayjs().endOf('day'),
  idFc: undefined,
  idStatus: undefined,
  idAr: undefined,
  invoiceNumber: undefined,
  invoiceKey: undefined,
  idSupplier: undefined,
})

const clearReceivementOverviewList = () => ({
  ...initialState,
})

const slice = createSlice({
  name: 'receivementOverviewList',
  initialState,
  reducers: {
    clearReceivementOverviewList,
    getReceivementOverviewList,
    setReceivementOverviewList,
    getReceivementStatusList,
    getFilterSuppliers,
    setDateInterval,
    updateOverviewFilterField,
    clearFilters,
  },
})

export default slice.reducer

export const { actions } = slice
